<template>
  <div id="app">
    <cookie-law>
      <div slot-scope="props">
        <p>
          This site uses cookies. By continuing to use this site you agree to our use of cookies.
        </p>
        <button class="cookie-btn" @click="props.accept"><span>I accept</span></button>
      </div>
    </cookie-law>
    <div class="page-changer" id="page-changer">
      <div>
        <preloader />
      </div>
    </div>
    <div
      :class="`_${ navigationColor } _background-${ backgroundColor }`"
    >
      <router-link
        :class="`menu-logo ${hideNavigationByScroll ? 'isHiddenByScroll' : ''} _${ navigationColor } a-link`"
        :event="''"
        :to="{ name: 'home' }"
        @click.native.prevent="onFollowLink({ name: 'home' })"
        @mouseenter="onLogoHover( $event )"
        @mouseleave="onLogoHoverOut( $event )"
        id="logo"
      >
        <svg width="56" height="34" viewBox="0 0 56 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0614 29.3222C7.95037 29.3222 4.60585 25.9251 4.60585 21.7494C4.60585 17.5735 7.95037 14.1766 12.0614 14.1766C16.1724 14.1766 19.5169 17.5735 19.5169 21.7494C19.5169 25.9251 16.1724 29.3222 12.0614 29.3222ZM21.5639 14.2307C19.3549 11.3567 15.9211 9.49805 12.0614 9.49805C5.41103 9.49805 0 14.9937 0 21.7494C0 28.5048 5.41103 34.0005 12.0614 34.0005C15.9211 34.0005 19.3549 32.1421 21.5639 29.2678V33.1751H26.17V10.3387H21.5639V14.2307Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M41.4522 29.3213C37.341 29.3213 33.9967 25.9242 33.9967 21.7485C33.9967 17.5726 37.341 14.1757 41.4522 14.1757C45.5632 14.1757 48.9082 17.5726 48.9082 21.7485C48.9082 25.9242 45.5632 29.3213 41.4522 29.3213ZM50.9553 0V14.2298C48.7458 11.3558 45.3125 9.49715 41.4522 9.49715C34.8019 9.49715 29.3906 14.9928 29.3906 21.7485C29.3906 28.5039 34.8019 33.9996 41.4522 33.9996C45.3125 33.9996 48.7458 32.1412 50.9553 29.2669V33.1742H55.5611V0H50.9553Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.76562 4.6783H26.1708V0H2.76562V4.6783Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M35.8582 1.03413C36.566 1.03413 37.1418 1.61915 37.1418 2.33813C37.1418 3.05711 36.566 3.64213 35.8582 3.64213C35.1501 3.64213 34.5742 3.05711 34.5742 2.33813C34.5742 1.61915 35.1501 1.03413 35.8582 1.03413ZM35.8582 4.44775C36.5227 4.44775 37.114 4.12781 37.4943 3.63272V4.30555H38.2874V0.3733H37.4943V1.04355C37.114 0.548454 36.5227 0.228516 35.8582 0.228516C34.713 0.228516 33.7812 1.17491 33.7812 2.33813C33.7812 3.50135 34.713 4.44775 35.8582 4.44775Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M45.2723 1.03413C45.9801 1.03413 46.5561 1.61915 46.5561 2.33813C46.5561 3.05711 45.9801 3.64213 45.2723 3.64213C44.5644 3.64213 43.9884 3.05711 43.9884 2.33813C43.9884 1.61915 44.5644 1.03413 45.2723 1.03413ZM45.2723 4.44775C45.9368 4.44775 46.5282 4.12781 46.9086 3.63272V4.30555H47.7017V0.3733H46.9086V1.04355C46.5282 0.548454 45.9368 0.228516 45.2723 0.228516C44.1271 0.228516 43.1953 1.17491 43.1953 2.33813C43.1953 3.50135 44.1271 4.44775 45.2723 4.44775Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M31.499 4.44798C31.9202 4.44798 32.3052 4.33804 32.6433 4.12122C32.9817 3.90392 33.2367 3.60188 33.4001 3.22379L33.4478 3.11267L32.6385 2.8683L32.5984 2.94693C32.4957 3.1501 32.3464 3.31348 32.1536 3.43308C31.9603 3.55244 31.7401 3.61318 31.499 3.61318C31.1514 3.61318 30.8561 3.4917 30.622 3.25369C30.3858 3.00555 30.2658 2.69762 30.2658 2.33813C30.2658 1.97511 30.3858 1.66953 30.622 1.42987C30.8524 1.18715 31.1474 1.06379 31.499 1.06379C31.7408 1.06379 31.961 1.1243 32.1536 1.24389C32.3464 1.36325 32.4957 1.52663 32.5984 1.72957L32.6385 1.80867L33.4478 1.56406L33.4001 1.45318C33.2369 1.07486 32.9822 0.773046 32.6433 0.55481C32.3047 0.338458 31.9197 0.228516 31.499 0.228516C30.9099 0.228516 30.4102 0.433097 30.0129 0.836375C29.6205 1.23494 29.4219 1.74039 29.4219 2.33813C29.4219 2.93092 29.621 3.43896 30.0143 3.84883C30.4153 4.24646 30.915 4.44798 31.499 4.44798Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M40.8318 4.44775C41.869 4.44775 42.5935 3.90675 42.5935 3.13197C42.5935 2.13496 41.6134 2.00383 40.8258 1.8986C40.3296 1.83221 39.901 1.775 39.901 1.52145C39.901 1.27355 40.1921 1.00706 40.8318 1.00706C41.443 1.00706 41.7629 1.27708 41.7629 1.54405V1.68766H42.5935V1.54405C42.5935 0.769515 41.869 0.228516 40.8318 0.228516C39.7946 0.228516 39.0703 0.769515 39.0703 1.54405C39.0703 2.46173 40.0004 2.5905 40.7477 2.69409C41.2923 2.76942 41.7629 2.83464 41.7629 3.15481C41.7629 3.40247 41.4715 3.66897 40.8318 3.66897C40.2206 3.66897 39.901 3.39894 39.901 3.13197V2.9886H39.0703V3.13197C39.0703 3.90675 39.7946 4.44775 40.8318 4.44775Z" fill="currentColor"/>
        </svg>
      </router-link>
      <a
        :class="`menu-burger ${hideNavigationByScroll ? 'isHiddenByScroll' : ''} ${ isMenuBurgerVisible ? '' : 'isHidden' }`"
        href="#"
        id="burger"
        @click.prevent="onMenuTooggle"
      >
        <span :class="`${showMenu ? 'active' : ''}`"></span>
      </a>
      <div class="menu" ref="menu">
        <div
          class="menu__background"
          ref="menuBackground"
          @click="onMenuHide"
        >
          
        </div>
        <div class="menu__container" ref="menuContainer">
          <!-- <div
            class="menu__close"
            @click="onMenuHide">
            <span></span>
          </div> -->
          <!-- <div class="menu__footer">
            {{ new Date().getFullYear() }}. AD CASA.
          </div> -->
          <div class="menu__inner">
            <div class="menu__block">
              <router-link
                :event="''"
                :to="{ name: 'projects', params: { activeSection: 'all' } }"
                @click.native.prevent="onMenuHide(); onFollowLink( { name: 'projects', params: { activeSection: 'all' } } )"
                class="a-link menu__title"
              >{{ $t('menu_projects') }}</router-link>
              <div class="menu__nav">
                <div class="">
                  <router-link
                    :event="''"
                    :to="{ name: 'projects', params: { activeSection: 'architecture' } }"
                    @click.native.prevent="onMenuHide(); onFollowLink( { name: 'projects', params: { activeSection: 'architecture' } } )"
                    class="a-link"
                  >{{ $t('section_architecture') }}</router-link>
                </div>
                <div class="">
                  <router-link
                    :event="''"
                    :to="{ name: 'projects', params: { activeSection: 'design' } }"
                    @click.native.prevent="onMenuHide(); onFollowLink( { name: 'projects', params: { activeSection: 'design' } } )"
                    class="a-link"
                  >{{ $t('section_design') }}</router-link>
                </div>
              </div>
            </div>
            <div class="menu__block">
              <router-link
                :event="''"
                :to="{ name: 'company' }"
                @click.native.prevent="onMenuHide(); onFollowLink( { name: 'company' } )"
                class="menu__title a-link"
              >{{ $t('menu_company') }}</router-link>
            </div>
            <div class="menu__block">
              <router-link
                :event="''"
                :to="{ name: 'contacts' }"
                @click.native.prevent="onMenuHide(); onFollowLink( { name: 'contacts' } )"
                class="menu__title a-link"
              >{{ $t('menu_contacts') }}</router-link>
              <!-- <div class="menu-nav">
                <div class="menu__link">
                  <a @click="onMenuHide" href="https://www.facebook.com/adorohovproject/" target="_blank">Facebook</a>
                </div>
                <div class="menu__link">
                  <a @click="onMenuHide" href="http://instagram.com/ad_project_" target="_blank">Instagram</a>
                </div>
              </div> -->
            </div>
            <div class="menu__social">
              <a href="https://www.instagram.com/ad_casa_/" target="_blank">
                <img src="/images/contact/Instagram.svg" alt="instagram" />
              </a>
              <a href="http://" target="_blank" class="social_disabled">
                <img src="/images/contact/In.svg" alt="In" />
              </a>
              <a href="http://" target="_blank" class="social_disabled">
                <img src="/images/contact/Facebook.svg" alt="Facebook" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <transition name="slide">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
import { TweenLite, Power2 } from 'gsap'
import { globalMixin, scrollMixin } from './mixins'
import preloader from './views/parts/preloader'
import CookieLaw from 'vue-cookie-law'

export default {
  mixins: [ globalMixin, scrollMixin ],

  components: {
    preloader,
    CookieLaw,
  },

  data() {
    return {
      showMenu: false,
    }
  },

  computed: {
    navigationColor () {
      return this.$store.getters.navigationColor
    },
    backgroundColor () {
      return this.$store.getters.backgroundColor
    },
    logoColor () {
      return this.$store.getters.logoColor
    },
    isMenuBurgerVisible () {
      return this.$store.getters.isMenuBurgerVisible
    },
    currentRouteName() {
      return this.$route.name;
    },
    hideNavigationByScroll() {
      if (this.currentRouteName === 'project') {
        return this.isScrollingDown;
      } else {
        return this.isMainMenuHidden;
      }
    },
  },

  methods: {
    onLogoHover( event ) {
      const logo = event.currentTarget
      TweenLite.to( logo, .5, {
        scale: 1.4,
        ease: Power2.easeInOut,
      } )
    },
    onLogoHoverOut( event ) {
      const logo = event.currentTarget
      TweenLite.to( logo, .5, {
        scale: 1,
        ease: Power2.easeInOut,
      } )
    },
    onMenuShow() {
      this.$refs.menu.style.display = 'block'
      TweenLite.to( this.$refs.menuBackground, .5, {
        opacity: 1,
        ease: Power2.easeInOut,
      } )
      TweenLite.to( this.$refs.menuContainer, .5, {
        x: '0%',
        ease: Power2.easeInOut,
      } )
      this.showMenu = true
    },

    onMenuTooggle() {
      if(this.showMenu) {
        this.onMenuHide()
      } else {
        this.onMenuShow()
      }
    },

    onMenuHide() {
      const self = this
      TweenLite.to( this.$refs.menuBackground, .5, {
        opacity: 0,
        ease: Power2.easeInOut,
        onComplete() {
          self.$refs.menu.style.display = 'none'
        }
      } )
      TweenLite.to( this.$refs.menuContainer, .5, {
        x: '100%',
        ease: Power2.easeInOut,
      } )
      this.showMenu = false
    },
  },

  mounted () {
    this.$store.commit('setFirstPage')
  },
}
</script>

<style lang="scss">
  @import './assets/css/normalize.css';
  @import './assets/vars.scss';

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom900-webfont.woff') format('woff');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom800-webfont.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom600-webfont.woff') format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom400-webfont.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom300-webfont.woff') format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom100-webfont.woff') format('woff');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'didot';
    font-weight: 700;
    src: url("/fonts/didot_bold.otf") format("opentype");
  }

  @font-face {
    font-family: 'didot';
    font-weight: 400;
    src: url("/fonts/didot_regular.otf") format("opentype");
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-MediumItalic.woff') format('woff');
      font-weight: 500;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-SuperItalic.woff') format('woff');
      font-weight: normal;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-SemiboldItalic.woff') format('woff');
      font-weight: 600;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Black.woff') format('woff');
      font-weight: 900;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Super.woff') format('woff');
      font-weight: normal;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Thin.woff') format('woff');
      font-weight: 100;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-ExtralightItalic.woff') format('woff');
      font-weight: 200;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Regular.woff') format('woff');
      font-weight: normal;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-BoldItalic.woff') format('woff');
      font-weight: bold;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-LightItalic.woff') format('woff');
      font-weight: 300;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-BlackItalic.woff') format('woff');
      font-weight: 900;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Medium.woff') format('woff');
      font-weight: 500;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Light.woff') format('woff');
      font-weight: 300;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Semibold.woff') format('woff');
      font-weight: 600;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Bold.woff') format('woff');
      font-weight: bold;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Extralight.woff') format('woff');
      font-weight: 200;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-ThinItalic.woff') format('woff');
      font-weight: 100;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-RegularItalic.woff') format('woff');
      font-weight: normal;
      font-style: italic;
  }

  #app .Cookie--base {
    all: unset;
    background: #FFFFFF;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);    
    position: fixed;
    bottom: 20px;
    left: auto;
    right: 20px;
    max-width: 375px;
    padding: 30px;
    display: block;
    z-index: 99;
    @media #{$mb} {
      right: auto;
      left: 0px;
      bottom: 0px;
      width: 100%;
      max-width: 100vw;
      padding: 10px 0px 10px 20px;
      box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.3);
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #303030;
      opacity: 0.5;
      letter-spacing: -0.03em;
      margin: 0;
      padding: 0;
       @media #{$mb} {
        padding: 0 40px 0 0;
      }
    }

    .cookie-btn {
      all: unset;
      margin-top: 30px;
      @media screen #{$mb} {
        margin-top: 20px;
      }
      span {
        cursor: pointer;
        font-style: normal;
        font-weight: 400;
        font-size: 26px;
        line-height: 130%;
        letter-spacing: -0.03em;
        color: #000000;
        text-decoration: none;
        color: inherit;
        transition: text-decoration-color 0.2s;
        position: relative;
        &:hover {
          &:before {
            content: "";
            position: absolute;
            width: 100%;
            bottom: -2px;
            left: 0;
            border-bottom: 1px solid rgba(38, 38, 38, 1);
          }
        }
        &:before {
          content: "";
          position: absolute;
          width: 0%;
          bottom: -2px;
          left: 0;
          border-bottom: 1px solid rgba(38, 38, 38, 1);
          transition: 0.2s;
        }
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          bottom: -2px;
          left: 0;
          border-bottom: 1px solid rgba(38, 38, 38, 0.1);
        }
        @media #{$mb} {
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 130%;
        }
      }
    }

    .Cookie--bottom {
      all: unset;
      left: auto;
      right: 20px;
      @media screen #{$mb} {
        right: 0px;
      }
    }
  }

  html {
    font-size: 16px;

    @media screen #{$mb} {
      font-size: 16px;
    }

    @media screen and (min-width: 769px) {
      @media screen and (max-width: 1200px) {
        font-size: 15px;
      }

      @media screen and (max-width: 1150px) {
        font-size: 14px;
      }

      @media screen and (max-width: 1100px) {
        font-size: 13px;
      }

      @media screen and (max-width: 1050px) {
        font-size: 12px;
      }

      @media screen and (max-width: 1000px) {
        font-size: 11px;
      }

      @media screen and (max-width: 950px) {
        font-size: 10px;
      }

      @media screen and (max-width: 850px) {
        font-size: 9px;
      }
    }
  }

  body {
    overflow-y: scroll;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Graphik LCG';
    font-size: 16PX;
    color: #303030;
    background: #F4F4F4;
  }

  .a-link {
    cursor: pointer;
    color: inherit;
    text-decoration: inherit;
  }

  .wrapper {
    padding-left: rem(172px);
    padding-right: rem(172px);

    max-width: 1450px;

    @media(min-width: 1500px) {
      max-width: 1200px;
      margin: 0 auto;
    }

    @media #{$mb} {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .menu-logo {
    position: fixed;
    text-decoration: none;
    z-index: 6;
    top: rem(25px);
    left: rem(60px);
    font-weight: 700;
    font-size: rem(22px);
    color: inherit;
    letter-spacing: 0;
    line-height: rem(64px);
    transition: all .2s ease;
    // backface-visibility: hidden;

    &._white {
      color: #fff;
    }

    &._black {
      color: #303030;
    }
    
    &.isHiddenByScroll {
      transform: translateY(-200%);
    }

    svg {
      @media #{$mb} {
        width: 37.5px
      }
    }

    @media #{$mb} {
      left: rem(20px);
      top: rem(20px);
      font-size: rem(20px);
      letter-spacing: rem(4px);
      line-height: rem(22px);
    }
  }

  .menu-burger {
    position: fixed;
    z-index: 101;
    top: rem(0px);
    right: rem(20px);
    width: rem(80px);
    height: rem(80px);
    transition: all .2s ease;

    &.isHidden {
      opacity: 0 !important;
      pointer-events: none;
    }

    &.isHiddenByScroll {
      transform: translateY(-200%);
    }

    @media #{$mb} {
      right: rem(10px);
      top: rem(15px);
      width: rem(40px);
      height: rem(40px);
      cursor: default;
    }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      width: rem(40px);
      margin-left: rem(-20px);
      height: rem(3px);
      margin-top: rem(-1.5px);

      @media #{$mb} {
        width: rem(38px);
        height: rem(3px);
        margin-left: rem(-24px);
      }

      &:before,
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #303030;
        transition: all .2s ease;
      }

      &:before {
        transform: translateY(-200%);

        @media #{$mb} {
          transform: translateY(-170%);
        }
      }

      &:after {
        transform: translateY(200%);

        @media #{$mb} {
          transform: translateY(170%);
        }
      }
    }

    span.active {
      &:before {
        transform: rotate(45deg) translateY(0%);
      }

      &:after {
        transform: rotate(-45deg) translateY(0%);
      }
    }
  }

  ._white {
    .index__menu {
        color: #fff;
    }

    .menu-burger {
        span {
            &:before,
            &:after {
                background: #fff;
            }
        }
    }

    .menu-logo {
      color: #fff;
    }

    .index__dots__item {
      span {
        background: #fff;
      }
    }

    .index__menu__link.hover-link {
      &:after {
        background: #fff;
      }
    }
  }

  ._background-black {
    background: #303030;
    color: #fff;

    .container__left,
    .container__right {
      border-color: transparent;
    }
  }

  .container {
    display: flex;
    min-height: 100vh;

    @media #{$mb} {
      display: block;
    }
  }

  .container__left {
    position: relative;
    width: rem(300px);
    min-width: rem(300px);
    border-right: rem(1px) solid #D0D0D0;

    @media #{$mb} {
      display: none;
    }
  }

  .container__image {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    width: rem(300px);
    bottom: 0;
    background: {
      size: cover;
      position: center;
    }
    transition: all .2s ease;

    &.isHidden {
      opacity: 0;
    }
  }

  .container__center {
    position: relative;
    width: 100%;
  }

  .container__right {
    width: rem(80px);
    min-width: rem(80px);

    @media #{$mb} {
      display: none;
    }
  }

  .menu {
    display: none;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .menu__container {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    background: #fff;
    width: rem(500px);
    height: 100vh;
    transform: translateX(100%);
    display: flex;
    padding-left: rem(80px);
    box-sizing: border-box;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;

    @media #{$mb} {
      width: 100%;
      padding-left: rem(45px);
    }
  }

  .menu__inner {
    padding: 148px 0 80px;
  }

  .menu__block {
    margin-top: rem(40px);

    &:first-child {
      margin-top: 0;
    }
  }

  .menu__title {
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.03em;
    color: #303030;
  }

  .a-link.menu__title {
    text-decoration: none;
    letter-spacing: -0.04em;
    transition: 0.2s;
    position: relative;
    &:hover {
      &:before {
        content: "";
        position: absolute;
        width: 100%;
        bottom: -2px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 1);
      }
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      bottom: -2px;
      left: 0;
      border-bottom: 1px solid rgba(38, 38, 38, 1);
      transition: 0.2s;
    }
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      bottom: -2px;
      left: 0;
      border-bottom: 1px solid rgba(38, 38, 38, 0.1);
    }
  }

  .menu__link {
    margin-top: rem(20px);

    a {
      text-decoration: underline;
      text-underline-offset: 3px;
      text-decoration-color: #979797;
      letter-spacing: -0.04em;
      text-decoration-thickness: 1px;
      color: inherit;
      transition: 0.2s;
      &:hover {
        text-decoration-thickness: 1px;
        text-decoration: underline;
      }
    }
  }

  .menu__background {
    position: absolute;
    opacity: 0;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .7);
  }

  .menu__close {
    position: absolute;
    top: rem(30px);
    right: rem(21px);
    width: rem(28px);
    height: rem(28px);
    cursor: pointer;

    @media #{$mb} {
      cursor: default;
    }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      width: rem(19px);
      height: rem(19px);
      margin-top: rem(-(19/2)+px);
      margin-left: rem(-(19/2)+px);
      
      &:before,
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -1px;
        margin-left: rem(-12px);
        background: #000;
        width: rem(24px);
        height: 2px;
      }

      &:before {
        transform: rotate(-45deg);
      }

      &:after {
        transform: rotate(45deg);
      }
    }
  }

  .menu__footer {
    position: absolute;
    left: rem(80px);
    bottom: rem(30px);
    opacity: 0.9;
    font-size: rem(12px);
    color: #303030;
    letter-spacing: 0.33px;
    line-height: rem(14px);

    @media #{$mb} {
      display: none;
    }

    a {
      color: inherit;
    }
  }

  .fixed-header {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;

    @media #{$mb} {
      left: 0;
      right: 0;
    }
  }

  .fixed-menu {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;

    @media #{$mb} {
      left: 0;
      right: 0;
    }
  }

  .bg-white {
    background: #F4F4F4;
  }

  .scroll-header {
    height: rem(96px);
    line-height: rem(96px);
    text-align: center;
    opacity: 0;
    pointer-events: none;
    cursor: pointer;
    transition: all .2s ease;

    @media #{$mb} {
      height: rem(64px);
      line-height: rem(64px);
      z-index: 5;
    }

    &.isVisible {
      opacity: 1;
      pointer-events: auto;
    }

    &.isHiddenByScroll {
      transform: translateY(-100%);
    }
  }

  .scroll-menu {
    opacity: 0;
    pointer-events: none;
    cursor: pointer;
    transition: all .2s ease;

    @media #{$mb} {
      height: rem(64px);
      line-height: rem(64px);
      z-index: 5;
    }

    &.isVisible {
      opacity: 1;
      pointer-events: auto;
    }

    &.isHiddenByScroll {
      transform: translateY(-100%);
    }
  }

  .scroll-header__title {
    font-family: 'Didot';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;

    @media #{$mb} {
      font-size: rem(18px);
    }
  }

  .loader {
    position: fixed;
    z-index: -1;
    top: -9999px;
    left: -9999px;
    pointer-events: none;
    opacity: 0;
  }

  /* Container */

  .container__cursor {
    position: fixed;
    top: 50%;
    left: rem(150px);
    transform: translate(-50%, -50%) rotate(-90deg);
    font-weight: 500;
    font-size: rem(18px);
    color: #000000;
    letter-spacing: 0.38px;
    line-height: rem(24px);
  }

  .arrow-left {
    position: fixed;
    z-index: 4;
    top: rem(39px);
    left: rem(361px);

    @media #{$mb} {
      display: none;
    }
  }

  .progress {
    position: fixed;
    top: 0;
    height: 4px;
    z-index: 4;
    left: 0;
    right: 0;

    @media #{$mb} {
      left: 0;
      right: 0;
      z-index: 5;
      height: 2px;
    }
  }

  .progress__bar {
    background: #303030;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0%;
  }

  .fixed-left-menu {
    position: fixed;
    top: rem(36px);
    z-index: 3;
    left: rem(460px);

    @media #{$mb} {
      display: none;
    }

    a {
      display: inline-block;
      margin-left: rem(60px);
      font-weight: 500;
      font-size: rem(18px);
      color: #303030;
      letter-spacing: 0.38px;
      line-height: rem(24px);
      text-decoration: none;

      &:first-child {
        margin-left: 0;
      }

      &.router-link-exact-active,
      &.isActive {
        opacity: .3;
      }
    }
  }

  .mobile-cursor {
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    top: rem(21px);
    z-index: 3;
    text-align: center;
    font-weight: 500;
    font-size: rem(18px);
    color: #303030;
    letter-spacing: 0.38px;
    line-height: rem(24px);

    &._white {
      color: #FFFFFF;
    }

    @media #{$mb} {
      display: block;
    }
  }


  @keyframes page-changer {
    0%   { transform: scale(1); }
    50%  { transform: scale(.8); }
    100% { transform: scale(1); }
  }

  .page-changer {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: #FAFAFA;

    div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      // animation: page-changer 2s infinite;
    }

    svg {
      display: block;
      position: absolute;
      max-width: 140px;
      width: 25%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) !important;
    }
  }

  .fixed-arrow {
    position: fixed;
    z-index: 4;
    right: rem(34px);
    bottom: rem(44px);
    width: rem(22px);
    height: rem(43px);
    background: url(/images/page-arrow-up.svg) center / contain no-repeat;
    cursor: pointer;
    transition: all .5s ease;
    
    @media #{$mb} {
      display: none;
    }

    &.isRotated {
      transform: rotate(-180deg);
    }

    &.isHidden {
      opacity: 0 !important;
    }

    &._no-transition {
      transition: all 0s ease;
    }
  }

  .hover-link {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      height: 1px;
      background: #030303;
      left: 50%;
      bottom: -.1em;
      transform: translateX(-50%);
      width: 0%;
      transition: all .3s ease;
    }

    &:hover {
      &:after {
        width: 100%;
      }
    }

    &._white {
      &:after {
        background: #fff;
      }
    }
  }

  .page-cursor {
    position: fixed;
    left: rem(188px);
    top: rem(36px);
    z-index: 4;
    font-weight: 500;
    font-size: rem(18px);
    color: #000000;
    letter-spacing: 0.38px;
    line-height: rem(24px);
    transition: all .2s ease;

    &.isHiddenByScroll {
      transform: translateY(-300%);
    }

    @media #{$mb} {
      display: none;
    }

    @media (min-width: 1441px) {
      left: calc(5% + 100px);
    }

    @media (min-width: 1460px) {
      left: calc(6% + 100px);
    }

    @media (min-width: 1480px) {
      left: calc(7% + 100px);
    }

    @media (min-width: 1500px) {
      left: calc(7% + 100px);
    }

    @media (min-width: 1550px) {
      left: calc(8% + 100px);
    }

    @media (min-width: 1580px) {
      left: calc(9.5% + 100px);
    }

    @media (min-width: 1610px) {
      left: calc(10% + 100px);
    }

    @media (min-width: 1630px) {
      left: calc(10.5% + 100px);
    }

    @media (min-width: 1650px) {
      left: calc(11.2% + 100px);
    }

    @media (min-width: 1680px) {
      left: calc(12% + 100px);
    }

    @media (min-width: 1700px) {
      left: calc(12% + 100px);
    }

    @media (min-width: 1715px) {
      left: calc(13% + 100px);
    }

    @media (min-width: 1730px) {
      left: calc(13% + 100px);
    }

    @media (min-width: 1760px) {
      left: calc(14% + 100px);
    }

    @media (min-width: 1800px) {
      left: calc(15% + 100px);
    }

    @media (min-width: 1920px) {
      left: calc(15.5% + 100px);
    }
  }

  ._white {
    .page-cursor {
      color: #fff;
    }
  }

  .project__preview {
    position: relative;
    color: #fff;
    height: 800px;
    min-height: 450px;
    display: flex;
    align-items: flex-end;
    background: {
      size: cover;
      position: center;
    }

    @media #{$mb} {
      height: 270px;
      min-height: auto;
    }

    &:before {
      content: "";
      position: absolute;
      z-index: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50%;
      background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.65) 70%, rgba(0,0,0,0.65) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 70%,rgba(0,0,0,0.65) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 70%,rgba(0,0,0,0.65) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#a6000000',GradientType=0 ); /* IE6-9 */
    }
  }

  .project__preview-content {
    // position: relative;
    z-index: 1;
    width: 100%;
    padding: 0 0 36px;

    @media #{$mb} {
      padding: 0 0 20px;
    }
  }

  .menu__nav {
    display: flex;
    gap: 20px;
    flex-direction: column;
    margin-top: 30px;
    margin-bottom: 50px;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.03em;
    margin-left: 30px;

    .a-link {
      opacity: 0.8;
      transition: opacity 0.2s;
      &:hover {
        opacity: 1;
      }
    }
  }

  .menu__social {
    display: flex;
    margin-top: 57px;
    justify-content: flex-start;
    gap: 30px;

    a:not(.social_disabled) {
      opacity: 1;
      transition: opacity 0.2s;
      &:hover {
        opacity: 0.7;
      }
    }

    .social_disabled {
      opacity: 0.5;
      cursor: auto;
    }
  }
</style>
